module.exports = __webpack_public_path__ + "img/忆海原识.1d2e400e.png";